
(function () {

  let isSorting = false;
  let observer;
  let sortType = null;

 
  function detectSortType() {

    const params = new URLSearchParams(
      window.location.search
    );

    if (
      params.get("custom_sort") ===
      "discount-high"
    ) {

      sortType = "high";

    } else if (
      params.get("custom_sort") ===
      "discount-low"
    ) {

      sortType = "low";

    } else {

      sortType = null;
    }

    updateSelectedOption();
  }

  function updateSelectedOption() {

    const select =
      document.getElementById(
        "SortByClone"
      );

    if (!select) return;

    const params =
      new URLSearchParams(
        window.location.search
      );

    const customSort =
      params.get("custom_sort");

    const nativeSort =
      params.get("sort_by") ||
      "best-selling";

    // REMOVE OLD
    select.querySelectorAll(
      "option"
    ).forEach(option => {

      option.selected = false;
      option.removeAttribute(
        "selected"
      );
    });

    document.querySelectorAll(
      '.select__dropdown [data-value]'
    ).forEach(span => {

      span.classList.remove(
        "selected"
      );
    });

    let activeValue;

    // CUSTOM SORT
    if (
      customSort === "discount-high" ||
      customSort === "discount-low"
    ) {

      activeValue = customSort;

    } else {

      activeValue = nativeSort;
    }

    // ACTIVE OPTION
    const activeOption =
      select.querySelector(
        `option[value="${activeValue}"]`
      );

    if (activeOption) {

      activeOption.selected =
        true;

      activeOption.setAttribute(
        "selected",
        "selected"
      );

      select.value = activeValue;
    }

    // ACTIVE SPAN
    const activeSpan =
      document.querySelector(
        `.select__dropdown [data-value="${activeValue}"]`
      );

    if (activeSpan) {

      activeSpan.classList.add(
        "selected"
      );
    }

    // UPDATE LABEL TEXT
    const selectedLabel =
      document.querySelector(
        '.select-selected'
      );

    if (
      selectedLabel &&
      activeOption
    ) {

      selectedLabel.textContent =
        activeOption.textContent.trim();
    }
  }

  
  function applyDiscountSort() {

    if (
      isSorting ||
      !sortType
    ) return;

    const grid =
      document.getElementById(
        "CollectionProductGrid"
      );

    if (!grid) return;

    isSorting = true;

    let items =
      Array.from(grid.children);

    items.sort(function (
      a,
      b
    ) {

      let p1 =
        a.querySelector(
          "[data-price]"
        );

      let p2 =
        b.querySelector(
          "[data-price]"
        );

      if (!p1 || !p2)
        return 0;

      let price1 =
        parseFloat(
          p1.dataset.price
        ) || 0;

      let compare1 =
        parseFloat(
          p1.dataset.compare
        ) || 0;

      let price2 =
        parseFloat(
          p2.dataset.price
        ) || 0;

      let compare2 =
        parseFloat(
          p2.dataset.compare
        ) || 0;

      let d1 =
        compare1 > 0
          ? (
              compare1 -
              price1
            ) / compare1
          : 0;

      let d2 =
        compare2 > 0
          ? (
              compare2 -
              price2
            ) / compare2
          : 0;

      return sortType ===
        "low"
        ? d1 - d2
        : d2 - d1;
    });

    items.forEach(el =>
      grid.appendChild(el)
    );

    setTimeout(() => {

      isSorting = false;

      updateSelectedOption();

    }, 100);
  }

  
  function initObserver() {

    const grid =
      document.getElementById(
        "CollectionProductGrid"
      );

    if (!grid) return;

    if (observer) {
      observer.disconnect();
    }

    if (!sortType) {
      return;
    }

    observer =
      new MutationObserver(
        function () {

          applyDiscountSort();

          updateSelectedOption();
        }
      );

    observer.observe(grid, {
      childList: true,
      subtree: false
    });
  }

  document.addEventListener(
    "click",
    function (e) {

      const span = e.target.closest(
        '.select__dropdown [data-value]'
      );

      if (!span) return;

      const value =
        span.getAttribute(
          "data-value"
        );

      if (!value) return;

     
      if (
        value === "discount-high" ||
        value === "discount-low"
      ) {

        e.preventDefault();
        e.stopPropagation();

        const url =
          new URL(
            window.location.href
          );

        url.searchParams.set(
          "custom_sort",
          value
        );

        url.searchParams.delete(
          "sort_by"
        );

        window.location.href =
          url.toString();

        return;
      }

      

      const url =
        new URL(
          window.location.href
        );

      url.searchParams.delete(
        "custom_sort"
      );
    }
  );


  document.addEventListener(
    "change",
    function (e) {

      const select =
        e.target.closest(
          "#SortByClone"
        );

      if (!select) return;

      const value =
        select.value;

      
      if (
        value === "discount-high" ||
        value === "discount-low"
      ) {

        const url =
          new URL(
            window.location.href
          );

        url.searchParams.set(
          "custom_sort",
          value
        );

        url.searchParams.delete(
          "sort_by"
        );

        window.location.href =
          url.toString();

        return;
      }

      

      updateSelectedOption();
    }
  );

 
  function initAll() {

    detectSortType();

    updateSelectedOption();

    if (sortType) {

      setTimeout(() => {

        applyDiscountSort();

        updateSelectedOption();

        initObserver();

      }, 200);
    }
  }

  document.addEventListener(
    "DOMContentLoaded",
    initAll
  );

  window.addEventListener(
    "load",
    initAll
  );

  document.addEventListener(
    "shopify:section:load",
    initAll
  );

})();